module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="form-group">\n    <input type="text" class="DescartesUIInput form-control" name="name" required="true"></input>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/SaveBookmarkDialog.ejs
// module id = 391
// module chunks = 0